var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.userImage)?_c('div',[_c('img',{staticClass:"default-user-icon",attrs:{"src":_vm.userImage}}),_vm._t("default")],2):_c('div',[_c('img',{staticClass:"default-user-icon",attrs:{"src":require("@/assets/profile-image-placeholder.svg")}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }